import Feature from "modules/Feature";
import HomeContent from "./components/HomeContent";
import Work from "modules/Work";
import Projects from "modules/Projects";
import Developer from "modules/Developer";
import Reviews from "modules/Reviews";
import AppVersion from "modules/AppVersion";
import FeatureBlog from "modules/FeatureBlog";
import Opportunity from "modules/Opportunity";
import Footer from "modules/Footer";
import Approach from "modules/Approach";
import Offers from "modules/Offers";
import Clients from "modules/Clients";
import { useEffect } from "react";
// import Loader from "components/common/Loader";

const Home = () => {
  useEffect(() => {
    document.body.className = "home-page bg-one";
  }, []);
  return (
    <>
      <HomeContent />
      <Clients />
      <Offers />
      <Developer />
      <Feature />
      <Approach />
      {/* <Work /> */}
      {/* <Reviews /> */}
      {/* <Projects /> */}
      <AppVersion />
      {/* <FeatureBlog /> */}
      <Opportunity />
      <Footer />
    </>
  );
};
export default Home;
